import React, { useState } from 'react';
import { storyblokEditable } from '@storyblok/react';
import CategoryNav from '~/components/CategoryNav';
import BlogPostPreview from '~/components/BlogPostPreview';
import useBlogPosts from '~/hooks/useBlogPosts';
import ResourcesNavigation from '../flexible/learn/ResourcesNavigation';

const Category = ({ blok }) => {
  const { name, categoryNavPage } = blok;
  const blogPosts = useBlogPosts();
  const posts = blogPosts.filter(rs => rs?.content?.category?.name === name);
  const initialNumPostsShown = 9;
  const [numPostsShown, setNumPostsShown] = useState(initialNumPostsShown);

  return (
    <main {...storyblokEditable(blok)}>
      <div className="">
        <ResourcesNavigation />

        <section className="my-16 hero">
          <div className="container space-y-4">
            <h1 className="u-h1 max-w-md mb-12" dangerouslySetInnerHTML={{ __html: `Posts in <span class="underswipe">${blok.name}</span>` }} />
            <CategoryNav categoryNavPage={categoryNavPage} />
          </div>
        </section>

        <section className="my-20">
          <div className="container ">
            <div className="grid grid-cols-1 gap-8 mt-10 md:grid-cols-2 lg:grid-cols-3 md:mt-16">
              {posts.slice(0, numPostsShown).map((rs, i) => (
                <BlogPostPreview key={`blog-post-${rs?.full_slug}`} {...rs} />
              ))}
            </div>
          </div>

          {numPostsShown < posts.length ? (
            <div className="mt-12 text-center md:mt-20">
              <a
                href="#"
                className="btn btn-black"
                onClick={e => {
                  e.preventDefault();
                  setNumPostsShown(numPostsShown + initialNumPostsShown);
                }}>
                Load more
              </a>
            </div>
          ) : null}
        </section>
      </div>
    </main>
  );
};

export default Category;
